import uniqueId from '@jetshop/core/helpers/uniqueId';
import { assign, Machine, send, spawn } from 'xstate';
import { notificationMachine } from './notificationMachine';
const notificationsMachine = Machine({
    id: 'notifications',
    context: {
        notifications: []
    },
    initial: 'idle',
    on: {
        'NOTIFICATION.ADD': {
            actions: assign({
                notifications: (context, event) => {
                    var _a;
                    const { content, id, notificationType } = event;
                    const newNotification = {
                        content,
                        id: id || uniqueId(),
                        type: notificationType !== null && notificationType !== void 0 ? notificationType : 'default',
                        autoCloseAfter: (_a = event.autoCloseAfter) !== null && _a !== void 0 ? _a : 1600
                    };
                    const ref = spawn(notificationMachine.withContext(newNotification), newNotification.id);
                    return [
                        ...context.notifications,
                        Object.assign(Object.assign({}, newNotification), { ref })
                    ];
                }
            }),
            target: 'active'
        }
    },
    states: {
        idle: {},
        active: {
            always: [
                {
                    target: 'idle',
                    cond: context => context.notifications.length === 0
                }
            ],
            on: {
                'NOTIFICATION.REMOVED': {
                    actions: assign({
                        notifications: (context, event) => {
                            return context.notifications.filter(notification => notification.id !== event.id);
                        }
                    })
                },
                'NOTIFICATION.REMOVE': {
                    actions: send('REMOVE', {
                        to: (_, event) => event.id
                    })
                },
                'NOTIFICATIONS.CLEAR': {
                    actions: context => {
                        for (const notification of context.notifications) {
                            notification.ref.send({ type: 'REMOVE' });
                        }
                    }
                }
            }
        }
    }
});
export { notificationsMachine };
//# sourceMappingURL=notificationsMachine.js.map